export default {
	launch: () => import('@/components/Auth/LaunchView'),
	categories: () => import('@/components/Search/CategoriesView'),
	details: () => import('@/components/Search/DetailsView'),
	results: () => import('@/components/Search/SearchResultsView'),
	login: () => import('@/components/Auth/LoginView'),
	register: () => import('@/components/Auth/RegisterView'),
	tos: () => import('@/components/Auth/TOS'),

	home: () => import('@/components/Main/HomeView'),
	settings: () => import('@/components/Settings/SettingsView'),
	accounts: () => import('@/components/Account/AccountsView'),
	donations: () => import('@/components/Main/RoundupListView'),
	designations: () => import('@/components/Main/DesignationListView'),

	preloadLaunch() {
		this.login()
		this.register()
	},

	preloadHome() {
		this.home()
		this.settings()
		this.accounts()
		this.donations()
	}
}
